/**
 * Vuex getters for the "spaces" (channels) module.
 *
 * Thin state accessors exposing channel data, the channel list, and the
 * following-list state as-is.
 */
export default {
  getChannelData: state => state.channelData,
  getChannelsList: state => state.channelsList,
  getFollowingList: state => state.followingList,
  getFollowingCount: state => state.followingCount,
};
